import React from 'react';
import { partial } from 'lodash';
import { SelectItem } from '../../Forms/SelectItem';
import { getTranslationKey } from '../../../modules/utils';
import { IShopSalesAutomation } from '../../../modules/types';
import { ISelectionOption } from '../../../modules/types/emails';
import { SelectWrapper } from './styles';

interface IProps {
  emailPackage: IShopSalesAutomation['emailPackage'];
  selectionOptions: ISelectionOption[];
  updateFormValue: (path: string, value: unknown) => void;
}

export const EmailPackageSection = React.memo(
  ({ emailPackage, selectionOptions, updateFormValue }: IProps) => (
    <SelectWrapper>
      <SelectItem
        label={getTranslationKey('shop.email-settings.package-title')}
        options={selectionOptions}
        value={emailPackage}
        changeCallback={partial(updateFormValue, 'emailPackage')}
      />
    </SelectWrapper>
  )
);
